import { CSSTransition } from "react-transition-group";

export default function Transition(props) {
  const { children } = props;
  const { visible, transition, appear } = props;

  const timeout = props.timeout || 500;
  const exit = props.disableExit ? false : true;

  return (
    <CSSTransition
      classNames={transition}
      appear={appear}
      in={visible}
      timeout={timeout}
      exit={exit}
      mountOnEnter={true}
      unmountOnExit={true}
    >
      <div
        className="w-full h-full"
        style={{ transitionDuration: `${timeout}ms` }}
      >
        {children}
      </div>
    </CSSTransition>
  );
}
